import { castToOption } from 'src/helpers';

export enum VendorPaymentTerms {
  Net15 = 'NET_15',
  Net21 = 'NET_21',
  Net30 = 'NET_30',
}

export const VENDOR_PAYMENT_TERMS_MAPPER: Record<VendorPaymentTerms, string> = {
  [VendorPaymentTerms.Net15]: 'NET 15',
  [VendorPaymentTerms.Net21]: 'NET 21',
  [VendorPaymentTerms.Net30]: 'NET 30',
};

export const vendorPaymentTermsOptions = castToOption(VendorPaymentTerms, VENDOR_PAYMENT_TERMS_MAPPER);
